import type { IconName } from '@similarweb/icons';

import { useIsWithinLinkedin } from '../../hooks/useIsWithinLinkedin';
import { useIsWithinTools } from '../../hooks/useIsWithinTools';
import { translate } from '../../services/i18n';

import {
  StyledTableEmptyContainer,
  StyledTableEmptyTitle,
  StyledTableEmptySubtitle,
  StyledTableEmptyIcon,
} from './styles';

export type TableEmptyStateView = 'noFilteredResults' | 'noResults';

const TABLE_EMPTY_STATE_VIEW: Record<TableEmptyStateView, { title: string; subtitle: string; iconName: IconName }> = {
  noFilteredResults: {
    title: 'company.technologies.no_filtered_results.title',
    subtitle: 'company.technologies.no_filtered_results.subtitle',
    iconName: 'no-data-lab',
  },
  noResults: {
    title: 'company.technologies.no_results.title',
    subtitle: 'company.technologies.no_results.subtitle',
    iconName: 'no-data-tree',
  },
};

export const TableEmptyState = ({ view }: { view: TableEmptyStateView }) => {
  const isWithinLinkedin = useIsWithinLinkedin();
  const { isWithinCalendar } = useIsWithinTools();
  const { title, subtitle, iconName } = TABLE_EMPTY_STATE_VIEW[view];
  return (
    <StyledTableEmptyContainer view={view}>
      <StyledTableEmptyIcon iconName={iconName} view={view} />
      <StyledTableEmptyTitle>{translate(title)}</StyledTableEmptyTitle>
      <StyledTableEmptySubtitle>
        {translate(isWithinLinkedin || isWithinCalendar ? `${subtitle}.linkedin` : subtitle)}
      </StyledTableEmptySubtitle>
    </StyledTableEmptyContainer>
  );
};
